import { Badge } from '@sravni/react-design-system/lib/Badge';
import { TimeDotted, DocumentEdit } from '@sravni/react-icons';

import { IRecentActionCard, IRecentActions } from '../types/recentActionCard';

export const getPrimaryAction = (data: IRecentActions): IRecentActionCard => data.orders[0] || data.calculations[0];
